import {
  useDisclosureStoreOptions,
  useDisclosureStoreProps
} from "./F6PEGR7W.js";
import {
  useStore
} from "./QPTZ2G2N.js";
import {
  __spreadValues
} from "./PNRLI7OV.js";

// src/dialog/dialog-store.ts
import * as Core from "@ariakit/core/dialog/dialog-store";
function useDialogStoreOptions(props) {
  return useDisclosureStoreOptions(props);
}
function useDialogStoreProps(store, props) {
  return useDisclosureStoreProps(store, props);
}
function useDialogStore(props = {}) {
  const options = useDialogStoreOptions(props);
  const store = useStore(
    () => Core.createDialogStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useDialogStoreProps(store, props);
}

export {
  useDialogStoreOptions,
  useDialogStoreProps,
  useDialogStore
};
